import { useState } from 'react';
import { Button, Modal, ModalHeader, ModalTitle, ModalBody } from 'reaxl';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
function DisclaimerWithModalContent(_ref) {
  let {
    container,
    mainText,
    modalTitle,
    modalText,
    modalTriggerText,
    block = false
  } = _ref;
  const [showModal, setShowModal] = useState(false);
  const toggleDisclaimerModal = () => {
    setShowModal(!showModal);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [mainText, ' ', /*#__PURE__*/jsx(Button, {
      bsStyle: "text-decorated",
      className: block && 'display-block text-center',
      onClick: toggleDisclaimerModal,
      children: modalTriggerText
    }), showModal && /*#__PURE__*/jsxs(Modal, {
      container: container,
      show: showModal,
      onHide: toggleDisclaimerModal,
      bsSize: "large",
      children: [/*#__PURE__*/jsx(ModalHeader, {
        closeButton: true,
        children: /*#__PURE__*/jsx(ModalTitle, {
          children: modalTitle
        })
      }), /*#__PURE__*/jsx(ModalBody, {
        children: modalText
      })]
    })]
  });
}
export { DisclaimerWithModalContent as default };
